<div class="container-fluid my-5">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item active" aria-current="page"> / Situation en chiffre</li>
    </ol>
  </nav>


  <form [formGroup]="updateNumbers" (ngSubmit)="updateData($event)">
    <div class="row">
        <div class="col-sm-6">
            <div class="form-group">
                <label>DÉCÈS</label>
                <input class="form-control" type="number" placeholder="RÉTABLI" formControlName="death">
            </div>
        </div>
        <div class="col-sm-6">
            <div class="form-group">
                <label>RÉTABLI</label>
                <input class="form-control" type="number" placeholder="DÉCÈS" formControlName="revealed">
            </div>
        </div>
        
      </div>
      <div class="row">
        <div class="col-sm-6">
            <div class="form-group">
                <label>NB QUARANTAINE</label>
                <input class="form-control" type="number" placeholder="NB QUARANTAINE" formControlName="quarantaine">
            </div>
        </div>
        <div class="col-sm-6">
            <div class="form-group">
                <label>CONFIRMÉ</label>
                <input class="form-control" type="number" placeholder="CONFIRMÉ" formControlName="totalcases">
            </div>
        </div>
        
      </div>
      <div class="row">
        <div class="col-sm-12">
            <div class="form-group">
                <button class="btn btn-primary" type="submit" [disabled]="! updateNumbers.valid" >MISE À JOUR</button>
            </div>
        </div>
        
      </div>

      <div class="row">
        <div class="col-sm-12">
            <div class="alert alert-success" *ngIf="updated">
                Les données ont bien été mises à jour.
            </div>
        </div>
      </div>
      
  </form>



  <div class="row">
    <div class="col-sm-12">

        <div class="form-group">
          <label>Coller de nouvelles données GeoJson</label>
          <textarea rows="10" class="form-control" [(ngModel)]="jsonData"></textarea>
        </div>

        <div class="form-group">
          <button class="btn btn-primary" (click)="getJSONData()" [disabled]="! jsonData">{{ btnmsg }} </button>
        </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12">
        <div class="alert alert-success" *ngIf="updatedMessage">
            Les données ont bien été mises à jour.
        </div>
    </div>
  </div>

</div>
